import React from 'react';
import styles from './styles';
import Select from 'react-select';
import {selectSettings} from '../../../selectSettings'
import Textarea from 'react-textarea-autosize'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import {SearchBar, Icons} from '@xpertdox_js/xdcomponents'
import TooltipItem from "../../../LabelTooltip";
import axiosConfig from '../../../../config/axios.config';
import { trackActivity } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'


const FormContent = props => {
  const {labelSettings, mutations, manualTrialForm} = props
  // console.log(labelSettings, props, "props")
  let label = labelSettings.dataTag;
  let refData = manualTrialForm.current[label];
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const inputChange = (e,label, type) => {
    let value = ''
    if(type==='dropdown'){
      let optionsWithArrays = ['pscore','mutationsIN','mutationsOUT']
      if(optionsWithArrays.includes(label)) value = e.map(v => v.value)
      else value = e ? e.value : ''
    }
    else if (type==='calendar'){
      value = moment(e).format('YYYY-MM-DD')
    } else value = e.target.value || e.target.id
    props.changeState()
    manualTrialForm.current[label] = value
  }

  const selectContditions = term => {
    let termToSave = {name1key:term.name1key,keyword:term.keyword,key_id:term.key_id}
    if(refData !== '') refData = [...manualTrialForm.current[label],termToSave].sort((a,b)=>b.keyword.length-a.keyword.length)
    else refData = [termToSave].sort((a,b)=>b.keyword.length-a.keyword.length)
    const uniq = Array.from(new Set(refData.map(a => a.keyword))).map(id => {return refData.find(a => a.keyword === id)})
    manualTrialForm.current[label] = uniq
    props.changeState()
  }

  const removeConditions = (e,term) => {
    for(let i=0;i<refData.length;i++) if(refData[i].keyword === term.keyword) refData.splice(i,1)
    manualTrialForm.current[label] = refData
    props.changeState()
    handleActivityLogUpdate(`FormContent.removeConditions.(${term})`)
  }

  const returnDropdownValue = (data, label) => {
    let returnValue = null
    if(data){
      if(typeof(data)==='string') {
        if(label==='genderToEdit') returnValue = {value: data==='M,F' ? 'All' : data, label: data==='M,F' ? 'All' : data}
        if(label==='recurrentToEdit') returnValue = {value: data, label: data===1 || data==='1' ? 'Yes' : 'No' }
        else returnValue = {value: data, label: data}
      }
      if(typeof(data)==='object' && data.length !== 0) {
        if(label==='pscore') returnValue = data.map(o=>({label:o===1 ? 'ECOG 0,1' : 'ECOG '+o,value:o}))
        else returnValue = data.map(o=>({label:o,value:o}))
      }
    }
    return returnValue
  }

  const renderEditOptions = settings => {
    const type = settings.typeEdit;
    const label = settings.dataTag
    let returnValue = 'N/A'
    if(type==='dropdown') {
      let returnBool = false;
      if(label==='phaseToEdit' && manualTrialForm.current.studyType==='Observational') returnBool = true
      returnValue = <Select
        label={label}
        isClearable={true}
        isDisabled={returnBool}
        defaultValue={returnBool ? {value:'N/A',label:'N/A'} : returnDropdownValue(manualTrialForm.current[label], label)}
        placeholder=''
        isMulti={settings.dropdownOptions.type !== 'single' ? true : false}
        options={!['mutationsIN','mutationsOUT'].includes(label) ? settings.dropdownOptions.options : mutations}
        styles={selectSettings.customStyles}
        theme={theme => selectSettings.selectTheme(theme)}
        onChange={e => inputChange(e, label, type)}
      />
    } if (type === 'textareaInput') {
      returnValue = <Textarea
        type='text'
        autoComplete='off'
        name={label}
        defaultValue={manualTrialForm.current[label]}
        ref={manualTrialForm[label]}
        style={{minHeight: "50px", minWidth: '100%'}}
        onChange={e => inputChange(e, label, type)} />
    } if (type==='calendar'){
      returnValue = <DatePicker
        dateFormat='yyyy-MM-dd'
        peekNextMonth
        name={label}
        autoComplete='off'
        minDate={label !== 'startDate' && manualTrialForm.current['startDate'] !== '' ? moment(manualTrialForm.current['startDate']).toDate() : null}
        showMonthDropdown
        showYearDropdown
        selected={manualTrialForm.current[label] !== '' ? moment(manualTrialForm.current[label]).toDate() : null}
        dropdownMode='select'
        onChange={e => inputChange(e, label, type)}
        required
      />
    } if(type==='searchBar'){
      returnValue = <div>
        <SearchBar {...props} axiosConfig={axiosConfig} type="diseases" index='master' selected={selectContditions}/>
        {manualTrialForm.current[label] !== '' && <div style={styles.termsContainer}>
          {manualTrialForm.current[label].map((c,i) => <p key={i} style={styles.term}>{c.keyword} <span style={styles.termRemove} onClick={(e) => removeConditions(e,c)}><Icons icon='times' style={styles.icon}/></span></p>)}
        </div>}
      </div>
    }
    if(type==='position') returnValue = <div style={styles.positionContainer}>
        {['Top','Bottom'].map((o,i) => <p key ={i} style={styles.positionBtn} id={o} onClick={e => inputChange(e, 'position', 'check')}><Icons id={o} icon={manualTrialForm.current.position===o ? 'check' : 'circleAlt'} style={styles.icon} /> {o} of list</p>)}
      </div>
    if(type==='numberInput') returnValue =  <input autoComplete='off' style={styles.textInput} defaultValue={manualTrialForm.current[label]} ref={manualTrialForm[label]} type='number' label={label} onChange={e => inputChange(e, label, type)}/>
    if(type === 'textInput') returnValue = <input autoComplete='off' style={styles.textInput} defaultValue={manualTrialForm.current[label]} ref={manualTrialForm[label]} type='text' label={label} onChange={e => inputChange(e, label, type)}/>
    return returnValue
  }
  return(
    <label style={styles.label} >
      <p className='heading'>
        {labelSettings.label}
        {labelSettings.required && <span style={styles.warning}>*</span>}
        {labelSettings.tooltip && <TooltipItem index={labelSettings.dataTag} text={labelSettings.tooltip} />}
      </p>
      {props.validators.msgs[labelSettings.dataTag] && <p style={styles.warning}>{props.validators.msgs[labelSettings.dataTag]}</p>}
      {renderEditOptions(labelSettings)}
    </label>
  )
}

export default FormContent;
